<template>
  <v-container id="page-hardware-list">
    <div class="page-title mb-10">{{$route.name}}</div>
    <v-row>
      <v-spacer></v-spacer>
    </v-row>
    <c-table
      :headers="hardwareTableHeaders"
      :items="hardwareItems"
    >
      <template #created="{ item }">
        {{ $func.dateTimeToString(item.created) }}
      </template>
      <template #plateNo="{ item }">
        {{ item.vehicleId ? item.vehicleId.plateNo : '-' }}
      </template>
      <template #updated="{ item }">
        {{ $func.dateToString(item.created) }}
      </template>
    </c-table>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        hardwareTableHeaders: [
          {
            text: 'OBD MAC 주소',
            value: 'macAddress',
            align: 'center',
            sortable: true,
          },
          {
            text: '등록 일시',
            value: 'created',
            align: 'center',
            sortable: true,
          },
          {
            text: '장착 차량',
            value: 'plateNo',
            align: 'center',
            sortable: true,
          },
          {
            text: 'OBD 기기 이름',
            value: 'nickName',
            align: 'center',
            sortable: true,
          },
          {
            text: '장착일',
            value: 'updated',
            align: 'center',
            sortable: true,
          },
        ],
        hardwareItems: []
      }
    },

    mounted() {
      this.reqObdDeviceInfoList();
    },

    methods: {
      async reqObdDeviceInfoList() {
        try {
          const res = await this.$api.getObdDeviceList();
          this.hardwareItems = res.data;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqObdDeviceInfoList'});
        }
      },
    }
  }
</script>

<style scoped>

</style>